import layout from '../view/layout'

const router = {
  name: 'member',
  path: 'member',
  component: layout,
  meta: {
    title: '会员管理',
    ico: 'el-icon-user-solid',
    authkey: 'member'
  },
  children: [
    {
      name: 'member_index',
      path: 'index',
      component: () => import('../view/member/index'),
      meta: {
        route_name: 'member_index',
        title: '会员列表',
        ico: '',
        isShow: true,
        authkey: 'member_index'
      }
    },
    {
      name: 'member_grade',
      path: 'grade',
      component: () => import('../view/member/member_grade'),
      meta: {
        route_name: 'member_grade',
        title: '会员身份',
        ico: '',
        isShow: true,
        authkey: 'member_grade'
      }
    },
    {
      name: 'member_log',
      path: 'log',
      component: () => import('../view/member/member_log'),
      meta: {
        route_name: 'member_log',
        title: '会员日志',
        ico: '',
        isShow: true,
        authkey: 'member_log'
      }
    },
    {
      name: 'member_grade_add',
      path: 'grade/add',
      component: () => import('../view/member/member_grade_add'),
      meta: {
        route_name: 'member_grade',
        title: '添加身份',
        ico: '',
        isShow: false,
        authkey: 'member_grade'
      }
    },
    {
      name: 'member_integral',
      path: 'integral',
      component: () => import('../view/member/integral'),
      meta: {
        route_name: 'member_integral',
        title: '积分明细',
        ico: '',
        isShow: true,
        authkey: 'member_integral'
      }
    },
    {
      name: 'member_balance',
      path: 'balance',
      component: () => import('../view/member/balance'),
      meta: {
        route_name: 'member_balance',
        title: '余额明细',
        ico: '',
        isShow: true,
        authkey: 'member_balance'
      }
    },
    {
      name: 'member_commission_order',
      path: 'commission_order',
      component: () => import('../view/member/commission_order'),
      meta: {
        route_name: 'member_commission_order',
        title: '业绩订单',
        ico: '',
        isShow: true,
        authkey: 'member_commission_order'
      }
    },
    {
      name: 'member_commission',
      path: 'commission',
      component: () => import('../view/member/commission'),
      meta: {
        route_name: 'member_commission',
        title: '业绩明细',
        ico: '',
        isShow: true,
        authkey: 'member_commission'
      }
    },
    {
      name: 'member_commission_order_detail',
      path: 'commission_order_detail',
      component: () => import('../view/member/commission_order_detail'),
      meta: {
        route_name: 'member_commission_order',
        title: '订单明细',
        ico: '',
        isShow: false,
        authkey: 'member_commission_order'
      }
    },
    {
      name: 'sys_store_apply',
      path: 'store/apply',
      component: () => import('../view/member/store_apply.vue'),
      meta: {
        route_name: 'sys_store_apply',
        title: '门店审核',
        ico: 'el-icon-c-scale-to-original',
        isShow: true,
        authkey: 'store_apply'
      }
    },
    {
      name: 'sys_store_apply_info',
      path: 'store/apply/info',
      component: () => import('../view/member/store_apply_info.vue'),
      meta: {
        route_name: 'sys_store_apply_info',
        title: '门店审核',
        ico: 'el-icon-c-scale-to-original',
        isShow: false,
        authkey: 'store_apply'
      }
    }
  ]
}

export default router
